(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["rewards-explainer"] && !Shopify.designMode) return;
  try {
    document.addEventListener('click', (event) => {
    const control = event.target.closest('[data-ebh-open-rewards]');
    if (!control) return;
    const launcher = document.getElementById('bon-loyalty-btn');
    if (!launcher) return;
    const cartDialog = control.closest('dialog.cart-drawer__dialog[open]');
    const closeButton = cartDialog?.querySelector('[ref="closeButton"]');
    if (cartDialog && closeButton) {
      cartDialog.addEventListener('close', () => launcher.click(), { once: true });
      closeButton.click();
    } else {
      launcher.click();
    }
  });
  } catch(e) { console.error(e); }
})();

})();
